import { jsx as ___EmotionJSX } from "@emotion/core";
import * as React from "react";
import { Property } from "./Editor";
import Select from "./Select";
import Option from "./Option";
import { map } from "ramda";

const SelectString = props => {
  const options = map(i => ___EmotionJSX(Option, {
    value: i,
    key: i
  }, i));
  return ___EmotionJSX(Property, {
    name: props.name
  }, ___EmotionJSX(Select, {
    value: props.value,
    onChange: e => props.onChange(e.target.value)
  }, options(props.values)));
};

export default SelectString;